import * as React from 'react';
import Svg, {
  SvgProps, G, Path, Defs, ClipPath,
} from 'react-native-svg';

const MeterIcon = (props: SvgProps) => (
  <Svg
    width={13}
    height={12}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill={props.fill ?? '#fff'}
        d="m11.781 4.5-6.53 6.53a.75.75 0 0 1-1.061 0L1.72 8.56a.75.75 0 0 1 0-1.06l1.367-1.367a.188.188 0 0 1 .265 0l1.633 1.632a.375.375 0 0 0 .549-.02.383.383 0 0 0-.028-.52L3.883 5.602a.188.188 0 0 1 0-.265l.703-.703a.188.188 0 0 1 .265 0l1.633 1.633a.375.375 0 0 0 .549-.02.383.383 0 0 0-.029-.52L5.383 4.102a.188.188 0 0 1 0-.265l.703-.703a.187.187 0 0 1 .265 0l1.633 1.633a.375.375 0 0 0 .549-.02.383.383 0 0 0-.029-.52L6.883 2.602a.188.188 0 0 1 0-.265L8.25.97a.75.75 0 0 1 1.061 0l2.47 2.47a.75.75 0 0 1 0 1.06Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill={props.fill ?? '#fff'} d="M.75 0h12v12h-12z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default MeterIcon;
